module.exports = __webpack_public_path__ + "f70c3159c26f5fa82453d931c9f59d21.jpg";